import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import OutflowsMoneyFlow from './OutflowsMoneyFlow';
import OutflowsMoneyFlowsHidden from './OutflowsMoneyFlowsHidden';

const OutflowsMoneyFlows = ({ collection }) => {
  const [currentStep, setCurrentStep] = React.useState(0);
  const stepsCount = collection?.resources()?.length();

  const resource = collection.resources().list()[currentStep];

  return (
    <FDBox key={resource.id()} flex={1}>
      {/* `MoneyFlow` only renders a single slide at a time. This causes the background image only to be loaded when we render it, causing it to jump in later.
        `MoneyFlowsHidden` renders all money flow background images with zero height/width, loading the images so then can enter smoothly on subsequent MoneyFlow slides. */}
      <OutflowsMoneyFlowsHidden collection={collection} />
      <OutflowsMoneyFlow
        resource={resource}
        currentStep={currentStep}
        stepsCount={stepsCount}
        setCurrentStep={setCurrentStep}
      />
    </FDBox>
  );
};

OutflowsMoneyFlows.propTypes = {
  collection: PropTypes.object.isRequired,
};

OutflowsMoneyFlows.defaultProps = {};

export default OutflowsMoneyFlows;
